<div class="input-group">
        <input type="text" 
        class="form-control"
        #inputCep
        [class.ng-invalid]="ngControl.invalid"
        [required]="required"
        [disabled]="disabled"
        [readonly]="readonly"
         maxlength="9"
        (keyup)="onKeyup($event)">
    <div class="input-group-append">
        <button type="button" class="btn btn-light" (click)="consultar()"
            id="btnConsultaCep" [disabled]="disabled">
            <i class="fas fa-search" aria-hidden="true"></i>
        </button>
    </div>    
</div>
<sgt-form-control-error
    *ngIf="ngControl.errors && ngControl.errors.cepInvalido"
    [msgError]="msgError">
</sgt-form-control-error>    
<sgt-form-control-error
    *ngIf="ngControl.errors && ngControl.errors.cepNaoEncontrado"
    [msgError]="msgError">
</sgt-form-control-error>    